/** Shared DPDP notice version — bump when privacy notice text changes materially. */
export const PRIVACY_NOTICE_VERSION = '2026-09-21';

export const ESSENTIAL_PURPOSES = [
  'account_auth',
  'ride_matching',
  'safety_communications',
  'fraud_prevention',
  'live_location_while_online',
];
